import { LogLevel } from "@azure/msal-browser";



export const msalConfig = {
    auth: {
      clientId: "8b5e9643-beac-4ea2-a4c1-efe305cd3d07",
      authority: "https://login.microsoftonline.com/264b9899-fe1b-430b-9509-2154878d5774", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
      redirectUri: "https://equaliser.lntecc.com",
    },
    cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
      loggerOptions: {	
          loggerCallback: (level, message, containsPii) => {	
              if (containsPii) {		
                  return;		
              }		
              switch (level) {
                  case LogLevel.Error:
                      console.error(message);
                      return;
                  case LogLevel.Info:
                     // console.info(message);
                      return;
                  case LogLevel.Verbose:
                  //    console.debug(message);
                      return;
                  case LogLevel.Warning:
                      console.warn(message);
                      return;
                  default:
                      return;
              }	
          }	
      }	
  }

  };
  
  // Add scopes here for ID token to be used at Microsoft identity platform endpoints.
  export const loginRequest = {
   scopes: ["User.Read"]
  };
  
  // Add the endpoints here for Microsoft Graph API services you'd like to use.
  export const graphConfig = {
      graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
  };


